/**
 * Shared IntersectionObserver helper — defer section JS until near viewport.
 * Looks the same; reduces main-thread work and media contention on mobile.
 */
(function () {
  const DEFAULT_MARGIN = '320px 0px';

  function whenVisible(el, callback, rootMargin) {
    if (!el || typeof callback !== 'function') return;

    const run = () => {
      try {
        callback();
      } catch (e) {
        console.error('[AdawatLazyInit]', e);
      }
    };

    if (!('IntersectionObserver' in window)) {
      run();
      return;
    }

    // Already in/near viewport — start immediately
    const rect = el.getBoundingClientRect();
    const vh = window.innerHeight || 800;
    if (rect.top < vh + 320 && rect.bottom > -160) {
      run();
      return;
    }

    const io = new IntersectionObserver(
      (entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        io.disconnect();
        run();
      },
      { root: null, rootMargin: rootMargin || DEFAULT_MARGIN, threshold: 0.01 }
    );
    io.observe(el);
  }

  window.AdawatLazyInit = { whenVisible };
})();
